export default __webpack_public_path__ + "static/bottom-2873ae420c59438a505f3a65a20d94b0.svg";